import axios from '@/lib/axios';
import { OrderAllocatedExpense, PaymentTaskComment, PurchaseOrderContractTaskComment } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 1193. 支払タスクプロジェクト按分費用登録
 * [POST] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/payment_tasks/:task_id/payment_task_fixed_assets
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  task_id: number;
  related_order_id: number;
  amount: number;
};
const createOrderAllocatedExpense = (props: Props): Promise<OrderAllocatedExpense> => {
  return axios.post(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/payment_tasks/${props.task_id}/order_allocated_expenses`,
    props
  );
};

export const useCreateOrderAllocatedExpense = () => {
  return useMutation({
    mutationFn: createOrderAllocatedExpense,
  });
};
